export default "__VITE_ASSET__Bta6VMWi__"